export function canDeleteProperty(input: { isOwner: boolean }): boolean {
	return input.isOwner
}

export function propertyDeleteApiPath(id: string): string {
	return `/api/common/properties/${encodeURIComponent(id)}`
}
